require('./ctxFiltersPanel.style.scss');

class FiltersPanelController {
    constructor($scope, $element, $timeout, docsService, $attrs) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$element = $element;
        this.docsService = docsService;
        this.$attrs = $attrs;
    }

    $onInit() {
        this.showFilterSelect = false;
        this.$timeout(() => (this.showFilterSelect = true), 100);
        this.closeId = this.$attrs.eventId;
        this.$element.on('keydown', (event) => {
            if (event.keyCode !== 13 || event.target.className === 'ctx-select-content') {
                return;
            }
            this.filter();
        });
        let scrollContainer = this.$element.find('.content[ctx-custom-scroll-bar]');
        scrollContainer.on('customScroll:initialized', (event) => {
            if (scrollContainer[0] === event.target) {
                this.$element.find('.filter:first-child').find('input').focus();
            }
        });

        this.fromPickerOptions = {
            locale:
                this.datetimeLocaleFormat && this.datetimeLocaleFormat.locale ? this.datetimeLocaleFormat.locale : 'en',
            format:
                this.datetimeLocaleFormat && this.datetimeLocaleFormat.format
                    ? this.datetimeLocaleFormat.format
                    : 'MM/DD/YYYY HH:mm',
            widgetPositioning: {
                horizontal: 'left',
                vertical: this.timeFilterDown ? 'bottom' : 'top',
            },
            showClear: true,
        };
        this.toPickerOptions = {
            locale:
                this.datetimeLocaleFormat && this.datetimeLocaleFormat.locale ? this.datetimeLocaleFormat.locale : 'en',
            format:
                this.datetimeLocaleFormat && this.datetimeLocaleFormat.format
                    ? this.datetimeLocaleFormat.format
                    : 'MM/DD/YYYY HH:mm',
            widgetPositioning: {
                horizontal: 'right',
                vertical: this.timeFilterDown ? 'bottom' : 'top',
            },
            showClear: true,
        };

        this.datePickerBFFunctions = {
            onShow: (data) => {
                let minDate = false,
                    timeFilter = this.filters.filter((f) => f.type === 'time')[0];
                if (timeFilter && timeFilter.dateAfterMilisec) {
                    minDate = moment(timeFilter.dateAfterMilisec).toDate();
                }
                if (data.picker && data.picker.minDate) {
                    data.picker.minDate(minDate);
                }
            },
        };

        this.datePickerAFFunctions = {
            onShow: (data) => {
                let maxDate = false,
                    timeFilter = this.filters.filter((f) => f.type === 'time')[0];
                if (timeFilter && timeFilter.dateBeforeMilisec) {
                    maxDate = moment(timeFilter.dateBeforeMilisec).toDate();
                }
                if (data.picker && data.picker.maxDate) {
                    data.picker.maxDate(maxDate);
                }
            },
        };

        this.$timeout(() => {
            let timeFilter = this.filters.filter((val) => val.selectedRadio === 'CUSTOM_RANGE');
            if (timeFilter.length > 0) {
                timeFilter.datetimeLocaleFormat = this.datetimeLocaleFormat;
                timeFilter[0].filterBy.forEach((val) => {
                    let input =
                        val.option === '#AFR#'
                            ? this.$element.find('#' + timeFilter[0].filterKey + '_dateAfter')
                            : this.$element.find('#' + timeFilter[0].filterKey + '_dateBefore');
                    input.data('DateTimePicker').date(moment.utc(val.value).toDate());
                });
            }
        }, 0);
        this.emptyRadio = [{ name: '', value: 'CUSTOM_RANGE' }];
    }

    close() {
        this.filters.forEach((filter) => filter.reset());
        this.onClose();
        this.showFilterSelect = false;
    }

    filter() {
        this.filters.forEach((filter) => filter.setFilterByOptions(filter));
        this.onFilter();
    }

    onUserHelp() {
        this.docsService.openHelp(this.helpId);
    }

    searchList(filterOption) {
        if (angular.isUndefined(this.searchTableState[filterOption.filterKey].searchBy) || !filterOption.hasSearchBox) {
            return;
        }
        filterOption.options = filterOption.originalList.filter(
            (op) =>
                op.label.toLowerCase().indexOf(this.searchTableState[filterOption.filterKey].searchBy.toLowerCase()) !==
                -1
        );
    }
}

const filtersPanelComponent = {
    controller: FiltersPanelController,
    scope: {},
    template: require('./ctxFiltersPanel.template.html'),
    bindings: {
        filters: '=',
        headerTitle: '=',
        timeFilterDown: '=',
        onFilter: '&',
        onClose: '&',
        helpId: '@?',
        datetimeLocaleFormat: '<?',
    },
};

FiltersPanelController.$inject = ['$scope', '$element', '$timeout', 'docsService', '$attrs'];

module.exports = filtersPanelComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxFiltersPanel/ctxFiltersPanel.component.js